import { createContext, useContext, ReactNode } from 'react';
import { useAuth } from '../hooks/useAuth';
import { useAutoTokenRefresh } from '../hooks/useAutoTokenRefresh';

interface AuthContextType {
  user: any;
  isLoading: boolean;
  isAuthenticated: boolean;
  userRole: any;
  storedUser: any;
  hasPermission: (permission: string) => boolean;
  isAdmin: () => boolean;
  canViewSalesReports: () => boolean;
  isOwner: () => boolean;
  isManager: () => boolean;
  isManagerOrKitchen: () => boolean;
  isWaiter: () => boolean;
  isKitchen: () => boolean;
  refreshUserToken: () => Promise<void>;
  forceRoleUpdate: () => Promise<void>;
  forceCompleteUpdate: () => Promise<void>;
  ensureValidToken: () => Promise<boolean>;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export function AuthProvider({ children }: { children: ReactNode }) {
  const auth = useAuth();
  
  // Inicializar auto-refresh de tokens con sistema inteligente
  useAutoTokenRefresh();

  return (
    <AuthContext.Provider value={auth}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuthContext() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuthContext must be used within an AuthProvider');
  }
  return context;
}

// Exportación de conveniencia para compatibilidad
export { useAuth } from '../hooks/useAuth'; 